/*
 UpdatedEmailVerification component
 url match: / or /login
 Displays email id and password field
 with UpdatedEmailVerification button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../../Styles/loginStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'

@inject('userStore')
@observer
class UpdatedEmailVerification extends React.Component {

    componentDidMount() {
        this.props.userStore.verifyUpdatedEmail(this.props.match.params['token'])
        this.props.history.push("/")
    }

    render() {
        const { classes, userStore } = this.props;
        if (!userStore.emailVerified && !userStore.inProgess) {
            return (
                <div className={classes.loaderDiv}><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
              )
        }
        return (
            <div className={classes.loginContainer} >
                <ReactSVG
                    beforeInjection={svg => {
                        svg.classList.add(classes.svg)
                    }}
                    src={Images.bigLogo} />
                { /*
                    !userStore.inProgess && !userStore.emailVerified ?
                    <p style={{color : 'white'}}>{userStore.statusText}</p> : 
                    <p style={{color : 'white'}}>Email verified successfully.&nbsp;
                        <Link to="/">Click here </Link> to login.
                </p>
                */ }
            </div>
        )
    }
}
export default withStyles(loginStyles, {withTheme: true})(withRouter(UpdatedEmailVerification));
